import React, {Component} from 'react';
import {LayoutSidebar} from "../../Layout";
import {ControlCentralContent} from "./control_central/ControlCentralContent";
import {PanelV11Content} from "./panel_v11/PanelV11Content";
import {useFicha21} from "../../context/UserModulesContext";
import {withRouterParams} from "../../utils/withRouterParams";

// Bifurcación de la ficha del cliente. `ficha21` ya incorpora el switch "Volver al Dashbo clásico":
// un usuario del tier UX_21 que volvió al clásico cae en `ControlCentralContent`, la pantalla de
// siempre, que no se toca.
//
// Hasta que llegan los módulos no se dibuja nada: pintar la pantalla vieja y reemplazarla cuando
// llega el flag es un flash de la ficha equivocada.
//
// revert = reemplazar el ternario por <ControlCentralContent/>
function PanelSwitch({clientId, history}) {
    const {ficha21, loaded} = useFicha21();

    if (!loaded) return null;

    return ficha21
        ? <PanelV11Content clientId={clientId} history={history}/>
        : <ControlCentralContent clientId={clientId} history={history}/>;
}

class ClientControlCentralComponent extends Component {
    render() {
        return (
            <div className="app-content">
                <LayoutSidebar/>
                <PanelSwitch
                    clientId={this.props.match.params.id}
                    history={this.props.history}
                />
            </div>
        );
    }
}

export default withRouterParams(ClientControlCentralComponent);
